<template>
  <div :class="{ 'form-group': withGroup && !withoutGroup, 'row': asRow }">
    <label
      v-if="label"
      :for="identifier"
      :class="labelClass">
      {{ label }}
    </label>
    <div :class="wrapClass">
      <div
        :class="{ 'input-group-lg': large, 'input-group-sm': small }"
        class="input-group">
        <div
          v-if="hasPrepend()"
          class="input-group-prepend">
          <div
            v-if="prepend"
            class="input-group-text">
            {{ prepend }}
          </div>
          <slot name="prepend"/>
        </div>
        <slot/>
        <div
          v-if="hasAppend()"
          class="input-group-append">
          <div
            v-if="append"
            class="input-group-text">
            {{ append }}
          </div>
          <slot name="append"/>
          <button
            v-tooltip="tooltip"
            v-if="tooltip"
            type="button"
            class="btn btn-light font-weight-bold form-tooltip"
            tabindex="-1">
            ?
          </button>
        </div>
      </div>
      <div class="invalid-feedback">
        {{ error }}
      </div>
    </div>
  </div>
</template>

<script>
import { FormInput } from '@/mixins'

export default {
  name: 'FormControl',

  mixins: [FormInput],

  mounted () {
    if (this.tooltip) {
      $('[data-toggle="tooltip"]').tooltip({
        container: 'body'
      })
    }
  }
}
</script>
